import { IconWrapper } from '../runtime';
export default IconWrapper('info', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.04004 5.99985C8.59232 5.99985 9.04004 5.55213 9.04004 4.99985C9.04004 4.44756 8.59232 3.99985 8.04004 3.99985C7.48775 3.99985 7.04004 4.44756 7.04004 4.99985C7.04004 5.55213 7.48775 5.99985 8.04004 5.99985Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.25 7.99979H7.75C8.02614 7.99979 8.25 8.22364 8.25 8.49979V11.4998M8.25 11.4998H7.25M8.25 11.4998H9.25M15 7.99982C15 11.8658 11.866 14.9998 8 14.9998C4.13401 14.9998 1 11.8658 1 7.99982C1 4.13382 4.13401 0.999817 8 0.999817C11.866 0.999817 15 4.13382 15 7.99982Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});